import { BaseEntityDto, UserDto, UserRole } from '@fleet-beat/core';
import { LogRecord } from './log-record.dto';

export interface LogHistoryRecord extends BaseEntityDto {
  id: string;
  driverId: string;
  actorId: string;
  actorType: `${UserRole}`;
  actorInfo: {
    id: string;
    fullName: string;
  };
  actionType: string;
  startedAt: string;
  endedAt: string;
  before?: LogRecord[];
  after?: LogRecord[];
  notes: string;
  actor: UserDto;

  selected?: boolean;
}
